import http from '@/utils/request'

 export default {
  getUserInfo: {
    url: 'system/user/profile',
    name: '个人信息',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  updatePwd: {
    url: 'system/user/profile/updatePwd',
    name: '修改密码',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  updateUserInfo: {
    url: 'system/user/profile/updateUserInfo',
    name: '编辑保存个人信息',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
 }